export default __webpack_public_path__ + "static/media/480_portfolio04-jp-mobile.cfcc9261.png";